import { apiFetchWeb } from "@/hooks/apiFetchWeb"
import { useQuery } from "@tanstack/react-query"

type FeatureItem = {
  key: string
  value: number
}

type WebsiteSettingsResponse = {
  data: {
    data: FeatureItem[]
  }
}

const fetchWebsiteSettings = async () => {
  return apiFetchWeb<WebsiteSettingsResponse>("website/get-features")
}

export const useWebsiteSettings = (enabled = true) => {
  return useQuery({
    queryKey: ["website-settings"],
    queryFn: fetchWebsiteSettings,
    enabled,
    staleTime: 1000 * 60 * 5,
    retry: 1,

    select: (res) => {
      const arr = res?.data?.data ?? []

      return Object.fromEntries(arr.map((f) => [f.key, Boolean(f.value)]))
    },
  })
}
